<template>
    <div class="page have-menu">
        <TopBar></TopBar>
        <div class="px-4 pt-4">
            <DashboardActivity
                :apiConfig="dashboardConfig"
                :modalController="modalController"
                @onLoaded="onLoadSuccess('dashboard')">
            </DashboardActivity>
        </div>
        <MenuBar :modalController="modalController"></MenuBar>
        <ModalMaster :controller="modalController"></ModalMaster>
    </div>
</template>
<script>
import ConfigManager from "@/config/ConfigManager.js";
//component
import TopBar from "@/components/Layout/TopBar/TopBar.vue";
import MenuBar from "@/components/Layout/MenuBar/MenuBar.vue";
import DashboardActivity from "@/components/Dashboard/DashboardActivity.vue";
//mixin
import ModalMixin from "@/mixin/ModalMixin.js";
import AuthPageMixin from "@/mixin/AuthPageMixin";


export default {
    name: "Activity",
    mixins: [ModalMixin,AuthPageMixin],
    components: {
        TopBar,
        DashboardActivity,
        MenuBar
    },
    data: function() {
        return {
            dashboardConfig: ConfigManager.getDashboardConfig().activityDashboard,
            loadingStatus: {
                dashboard: false,
            },
        };
    },
    created: function() {
        this.tracking.screenName('activity');
        this.tracking.event('activity', 'view_activity');

    },
    mounted: function() {
        this.loadingModal.show();
    },
    beforeUnmount: function() {

    },
    methods: {


        onLoadSuccess: function(api) {
            if (!this.loadingStatus[api]) {
                this.loadingStatus[api] = true;
                let found = false;
                for (let i in this.loadingStatus) {
                    if (!this.loadingStatus[i]) {
                        found = true;
                        break;
                    }
                }
                if (!found) {
                    this.loadingModal.hide();
                }
            }
        },
    },
}
</script>
